import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class QueryParserService {

  parseFieldQuery(queryField: string, query: string, returnWildcardString: boolean = false) {
    if (queryField === 'content') {
      // For content searches, do not modify the query except for adding wildcards if needed
      return this.parse(query, returnWildcardString)
    }
    let parsedQuery: string;
    if (queryField.endsWith('upper')) {
      // Only change to upper case for upper case fields!!
      parsedQuery = this.parse(query, true, ' ', '_', returnWildcardString).toLocaleUpperCase();
    } else {
      parsedQuery = this.parse(query, true, '', '', returnWildcardString)
    }
    return parsedQuery;
  }

  parse(query: string, addWildCards: boolean, replaceFromString?: string, replaceWithString?: string, returnWildcardString: boolean = false) {
    let res = '';

    query = this.removeIllegalText(query);
    addWildCards = this.getAddWildCards(query, addWildCards);
    if (query) {
      if (returnWildcardString) {
        return query.split(' ').map(q => `*${q}*`).join('-_-');
      }

      const qTrim = query.trim();
      if (qTrim.startsWith('"') && qTrim.endsWith('"')) {
        return qTrim.substring(1, qTrim.length - 1);
      }
      const hasQuotes = ['"', '\''].includes(qTrim.substring(qTrim.length - 1));
      res = this.splitAndCombineQuery(query, hasQuotes, addWildCards);
      if (replaceFromString && replaceWithString) {
        res = res.replaceAll(replaceFromString, replaceWithString)
      }
      res = res.trim();
      if (addWildCards && res.split(' ').length === 1 && !hasQuotes) {
        res = '*' + res;
      }
    } else if (addWildCards) {
      res = '*:*';
    }
    return res;
  }

  private getAddWildCards(query: string, addWildCards: boolean = true) {
    if (addWildCards && query?.includes('~') || query?.includes('^')) {
      addWildCards = false;
    }
    return addWildCards;
  }

  private splitAndCombineQuery(query: string, hasQuotes: boolean, addWildCards: boolean) {
    let res = '';
    let spc = '';
    const qSplit = this.cleanSplit(query);
    if (qSplit.length > 0) {
      for (let t = 0; t < qSplit.length - 1; t++) {
        res += spc + qSplit[t];
        spc = ' ';
      }
      const last = this.clean(qSplit.at(-1));
      res += spc + last;
      res = res.trim();
      if (!hasQuotes && addWildCards) {
        res += '*';
      }
    }
    return res;
  }

  private cleanSplit(query: string) {
    return query.split(/[\s/()\-+:«»;,.&"]/g).filter(q => q !== '' && q !== ' ');
  }

  private removeIllegalText(query: string) {
    const requireStarts = ['^','AND', 'OR'];
    const requireEnds = ['^', 'OR', 'AND', 'NOT'];
    query = query ? query.trim() : '';
    if (!query) {
      return query;
    }
    for (const requireStart of requireStarts) {
      if (query.startsWith(requireStart)) {
        query = query.substring(requireStart.length).trim();
      }
    }
    for (const requireEnd of requireEnds) {
      if (query.endsWith(requireEnd)) {
        query = query.substring(0, query.length - requireEnd.length).trim();
      }
    }
    const indexOfHat = query.indexOf('^');
    if (indexOfHat !== -1) {
      const nextChar = query.charAt(indexOfHat + 1);
      // Must remove the ^ character if next character is not number, else search will fail
      const nextCharNumber = Number(nextChar);
      if (Number.isNaN(nextCharNumber)) {
        return query.replace('^', '');
      }
    }
    return query;
  }

  private clean(query: string) {
    return query.replaceAll(/[[\]{}]/g, '').trim();
  }

}
